import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchProjectEndPoint, patchProjectEndPoint , setPageSize , clearCache} from "@/slices/accessManager/AccessAppProjectEndPointSlice";

import Loader from '../../components/Loader';
import EditableTable from "./AccessManagerTable";
import Modal from "../../components/Modal";
import ChangeLog from "../../components/ChangeLog";
import SimplePagination from "@/components/SimplePagination";
import PanelUserSearch from "@/components/PanelUserSearch";
import PageSizeSelector from "@/components/PageSizeSelector";

const AccessProjectEndPoint = () => {
  const dispatch = useDispatch();
  const { accessProjectEndPointCategoryList, currentPage, totalPages, status,  search , pageSize } = useSelector((state) => state.accesprojectendPointManager);
  const [editRowId, setEditRowId] = useState(null);
  const [editedData, setEditedData] = useState({});
  const [searchInput, setSearchInput] = useState(search || "");
  
 
  const headers = accessProjectEndPointCategoryList?.result?.length > 0 ? Object.keys(accessProjectEndPointCategoryList?.result[0]).filter((key) => key !== 'id') : [];
  const editableFields = ['message','active']; // Define editable fields

  const [currentLog,setCurrentLog] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const handleLog = (id)=>{
    const logData = accessProjectEndPointCategoryList?.Change_Log?.filter((f)=>f.id===id)[0]?.oldTrack;
    setCurrentLog(logData)
    openModal()
  }

  useEffect(() => {
    dispatch(fetchProjectEndPoint({page: 1 , search}));
  }, [dispatch]);
    
    const isSearching = searchInput && searchInput.trim() !== "";
    const hasData = accessProjectEndPointCategoryList?.result?.length > 0;

     // ✅ Page size change
      const handlePageSizeChange = (size) => {
        dispatch(setPageSize(size)); // update slice
        dispatch(fetchProjectEndPoint({ page: 1 , search}));
      }; 
  
     useEffect(() => {
       setSearchInput(search || "");
     }, [search]);
  
        // ✅ Debounced search (MAIN CONTROL)
      useEffect(() => {
        const timer = setTimeout(() => {
          dispatch(fetchProjectEndPoint({ page: 1, search: searchInput }));
        }, 800);
    
        return () => clearTimeout(timer);
      }, [searchInput]);
  

  if (status === "loading") {
    return (
      <div className="w-full pt-20 flex justify-center">
        <Loader />
      </div>
    );
  }


  const handleEdit = (rowId) => {
    setEditRowId(rowId);
    const rowData = accessProjectEndPointCategoryList?.result?.find((user) => user.id === rowId);
    setEditedData(rowData);
  };

  const handleSave = async () => {
    const { id, message,active } = editedData;
    const updatedData = { id, message,active };
    console.log(updatedData)
    const resp = await dispatch(patchProjectEndPoint(updatedData));
    if (!resp.error) {
      setEditRowId(null);
      await dispatch(clearCache()); // resets cache internally
      dispatch(fetchProjectEndPoint({ page: 1, search : ""}));
    }
  };

  const handleCancel = () => {
    setEditRowId(null);
    setEditedData({});
  };

  const handleChange = (e, field,val) => {
      if(field==="active"){
        setEditedData((prev) => ({
          ...prev,
          [field]:!val,
        }));
      }else{
        setEditedData((prev) => ({
          ...prev,
          [field]:e.target.value,
        }));
      }
     
   
  };

  return (
    <div className="w-full flex items-center flex-col">
            <PanelUserSearch  
           value={searchInput}
           onChange={setSearchInput}
          />

      <div className="max-w-full">
          {hasData ? (
       <EditableTable
        headers={headers}
        rows={accessProjectEndPointCategoryList?.result}
        editRowId={editRowId}
        editedData={editedData}
        handleEdit={handleEdit}
        handleSave={handleSave}
        handleCancel={handleCancel}
        handleChange={handleChange}
        handleLog={handleLog}
        editableFields={editableFields} // Pass editable fields
      />
      ) : (
    <div className="w-full flex flex-col items-center justify-center py-20 text-gray-500">

      {/* Icon */}
      <div className="text-5xl mb-3">🔍</div>

      {/* Message */}
      {searchInput ? (
        <>
          <p className="text-lg font-medium">No results found</p>
          <p className="text-sm mt-1">
            for "<span className="font-semibold">{searchInput}</span>"
          </p>
        </>
      ) : (
        <>
          <p className="text-lg font-medium">No Data Available</p>
          <p className="text-sm mt-1">
            There are no users to display
          </p>
        </>
      )}

    </div>
  )}
      </div>



 {!(isSearching && !hasData) && (
<div className="flex mt-4 items-center justify-between w-11/12">

    <PageSizeSelector
      pageSize={pageSize}
      setPageSize={handlePageSizeChange}
    />

  <SimplePagination
    currentPage={currentPage}
    setCurrentPage={(page) =>
      dispatch(fetchProjectEndPoint({ page , search: searchInput }))
    }
    totalPages={totalPages}
  />
    </div>
  )}

      <Modal
        isOpen={isModalOpen}
        onClose={closeModal}
        title="Change Log"
        content={<ChangeLog data={currentLog}/>}
      />

    </div>
  );
};

export default AccessProjectEndPoint;
